import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'add-recipient',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './add-recipient.html',
  styleUrl: './add-recipient.css',
})
export class AddRecipientModal {
  @Input() className: string = '';
  @Input({ required: true }) open: boolean = false;
}
